export default __webpack_public_path__ + "static/media/screen4.27cdf5d6.png";